import client from './client'

export interface AcquisitionJob {
  id: number
  status: string
  playEnvId?: number
  snapshotId?: number
  totalTargets?: number
  candidatesFound?: number
  downloadsOk?: number
  downloadsFailed?: number
  startedAt?: string
  finishedAt?: string
  etaSec?: number
  progressPct?: number
}

export interface JobResult {
  romEntryName?: string
  source?: string
  identifier?: string
  status: string
  bytes?: number
  actualSha1?: string
  message?: string
}

export interface SourceInfo {
  name: string
  available: boolean
  notes?: string
  configHints?: Record<string, unknown>
}

export interface CreateJobRequest {
  playEnvId: number
  snapshotId: number
  systemSlug?: string
  sources?: string[]
  maxDownloads?: number
  extraQueries?: string[]
  targets?: Array<{ name: string; sha1: string; crc32?: string; size?: number }>
}

export const acquisitionApi = {
  listJobs: () => client.get<AcquisitionJob[]>('/acquisition/jobs').then((r) => r.data),
  getJob: (id: number) => client.get<AcquisitionJob>(`/acquisition/jobs/${id}`).then((r) => r.data),
  results: (id: number) =>
    client.get<JobResult[]>(`/acquisition/jobs/${id}/results`).then((r) => r.data),
  create: (req: CreateJobRequest) =>
    client.post<AcquisitionJob>('/acquisition/jobs', req).then((r) => r.data),
  cancel: (id: number) => client.post(`/acquisition/jobs/${id}/cancel`).then((r) => r.data),
  sources: () => client.get<SourceInfo[]>('/acquisition/sources').then((r) => r.data),
}
